import React from "react";

interface QuoteYesNoQuestionProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
}

export default function QuoteYesNoQuestion({
    label,
    value,
    onChange
}: QuoteYesNoQuestionProps) {
    return (
        <div className="quote-ad-question">
            <p>{label}</p>

            <div className="quote-ad-options">
                <button
                    type="button"
                    className={value === "1" ? "selected" : ""}
                    onClick={() => onChange("1")}
                >
                    Yes
                </button>

                <button
                    type="button"
                    className={value !== "1" ? "selected" : ""}
                    onClick={() => onChange("0")}
                >
                    No
                </button>
            </div>
        </div>
    );
}